const uiSchema = () => ({
  key: {
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
